import React from 'react';
import ReactDOM from 'react-dom';

import RootContainer from './modules/root';
import { history } from './wlHistory';

export default () =>
  ReactDOM.render(
    <RootContainer history={history} />,
    document.getElementById('reactContainer'),
  );
